// Route stub created by tools/gen_web_routes.py from contract/catalog/screens.json; owned by hand from here on.
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageHeader } from '../../components/ui/page-header'
import '../../shared/shell/strings'

export const Route = createFileRoute('/platform/jobs')({
  staticData: { screenId: 'ConsoleJobsScreen', access: 'platform.jobs.read' },
  component: ConsoleJobsScreen,
})

function ConsoleJobsScreen() {
  const { t } = useTranslation()
  return (
    <main data-testid="ConsoleJobsScreen">
      <PageHeader title={t('shell.nav.jobs')} titleTestId="consoleJobs_titleValue" />
    </main>
  )
}
